import {
    call,
    put,
    SagaReturnType,
    takeLatest,
} from 'redux-saga/effects'

import { LoginFormData } from '../../@paco/entities/@forms/LoginForm/LoginForm'
import { setIsUserIdle } from '../../@paco/redux/authenticatedUser/authenticatedUserReducer'

import { authenticateUserRequest, forgotPasswordRequest, patchUserPassword } from '../../helpers/api/authenticationApi'
import {
    APP_SAGA_INIT,
    APP_SAGA_LOGOUT,
    AUTH_AUTHENTICATE_FAILURE,
    AUTH_AUTHENTICATE_REQUEST,
    AUTH_FORGOT_PASSWORD_FAILURE,
    AUTH_FORGOT_PASSWORD_REQUEST,
    AUTH_FORGOT_PASSWORD_SUCCESS,
    AUTH_SAGA_AUTHENTICATE_USER,
    AUTH_SAGA_FORGOT_PASSWORD,
    AUTH_SAGA_SUBMIT_PASSWORD,
    AUTH_SAGA_UPDATE_API_TOKEN,
    AUTH_SAGA_UPDATE_REFRESH_TOKEN,
    AUTH_SET_API_TOKEN,
    AUTH_SET_REFRESH_TOKEN,
    AUTH_SUBMIT_PASSWORD_FAILURE,
    AUTH_SUBMIT_PASSWORD_REQUEST,
    AUTH_SUBMIT_PASSWORD_SUCCESS,
    AUTH_UNSET_TOKENS,
} from '../actionTypes'
import { authAuthenticateSuccess } from './authenticationReducer'

interface AuthenticateUserParams {
    type: string;
    credentials: LoginFormData;
}

type AuthResponse = SagaReturnType<typeof authenticateUserRequest>;

function* authenticateUser(action: AuthenticateUserParams): Generator<any, void, AuthResponse> {
    yield put({ type: AUTH_AUTHENTICATE_REQUEST })

    try {
        const response: AuthResponse = yield call(() => authenticateUserRequest(action.credentials))

        yield put(authAuthenticateSuccess({
            apiToken: response.data.token,
            apiRefreshToken: response.data.refresh_token,
            rememberMe: action.credentials.rememberMe,
        }))

        yield put({ type: APP_SAGA_INIT })
        yield put(setIsUserIdle(false))
    } catch (error) {
        yield put({ type: AUTH_AUTHENTICATE_FAILURE })
    }
}

interface SetApiTokenParams {
    type: string;
    apiToken: string;
}

function* setApiToken(action: SetApiTokenParams) {
    yield put({ type: AUTH_SET_API_TOKEN, apiToken: action.apiToken })
}

interface SetRefreshTokenParams {
    type: string;
    refreshToken: string;
}

function* setRefreshToken(action: SetRefreshTokenParams) {
    yield put({ type: AUTH_SET_REFRESH_TOKEN, refreshToken: action.refreshToken })
}

function* unsetTokens() {
    yield put({ type: AUTH_UNSET_TOKENS })
}

interface SubmitPasswordParams {
    type: string;
    userId: string;
    password: string;
    pincode: string;
}

function* submitPassword({ userId, password, pincode }: SubmitPasswordParams) {
    yield put({ type: AUTH_SUBMIT_PASSWORD_REQUEST })

    try {
        yield call(() => patchUserPassword(userId, password, pincode))

        yield put({ type: AUTH_SUBMIT_PASSWORD_SUCCESS })
        yield put({ type: AUTH_UNSET_TOKENS })
    } catch (error) {
        yield put({ type: AUTH_SUBMIT_PASSWORD_FAILURE })
    }
}
interface ForgotPasswordParams {
    type: string;
    email: string;
    userId: string;
}

export function* forgotPassword({ email, userId }: ForgotPasswordParams) {
    yield put({ type: AUTH_FORGOT_PASSWORD_REQUEST })

    try {
        yield call(() => forgotPasswordRequest(email, userId))

        yield put({ type: AUTH_FORGOT_PASSWORD_SUCCESS })
    } catch (error) {
        yield put({ type: AUTH_FORGOT_PASSWORD_FAILURE })
    }
}


export default function* authenticationWatcher() {
    yield takeLatest(AUTH_SAGA_AUTHENTICATE_USER, authenticateUser)
    yield takeLatest(AUTH_SAGA_UPDATE_API_TOKEN, setApiToken)
    yield takeLatest(AUTH_SAGA_UPDATE_REFRESH_TOKEN, setRefreshToken)
    yield takeLatest(APP_SAGA_LOGOUT, unsetTokens)
    yield takeLatest(AUTH_SAGA_SUBMIT_PASSWORD, submitPassword)
    yield takeLatest(AUTH_SAGA_FORGOT_PASSWORD, forgotPassword)
}
